import { render, staticRenderFns } from "./StatusButton.vue?vue&type=template&id=d56a2bc6&"
import script from "./StatusButton.vue?vue&type=script&lang=js&"
export * from "./StatusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d56a2bc6')) {
      api.createRecord('d56a2bc6', component.options)
    } else {
      api.reload('d56a2bc6', component.options)
    }
    module.hot.accept("./StatusButton.vue?vue&type=template&id=d56a2bc6&", function () {
      api.rerender('d56a2bc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/StatusButton.vue"
export default component.exports